import {generate} from 'helpers';
import {Unit} from 'types';
import {select} from 'store/helpers';
import {units, getByName} from './selectors';

export const upsert = (name?: string) => ({
  type: 'UNIT_UPSERT' as const,
  unit: name && name.trim() ? {
    ...select(getByName)(name) ?? create(name),
    name
  } : undefined
});

export const rename = (id: string, name: string) => ({
  type: 'UNIT_RENAME' as const,
  id,
  name: name.trim()
});

export const remove = (ids: string[]) => ({
  type: 'UNIT_REMOVE' as const,
  ids
});

const create = (name: string): Unit => ({
  category: '',
  isDefault: false,
  name: name.trim(),
  orderIndex: select(units).maxOrderIndex + 1,
  serverId: generate()
});
